export function decodeJWT<T = unknown>(token: string): T | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const payload = parts[1];
    const decoded = JSON.parse(
      atob(payload.replace(/-/g, '+').replace(/_/g, '/')),
    );

    return decoded as T;
  } catch (error) {
    console.error('[JWT] Decode error:', error);
    return null;
  }
}
